// extracted by mini-css-extract-plugin
export default {"canvas":"trailMouse_canvas__NJ6kp"};